<template>
  <div id="cover-spin" :style="styling">
  </div>
</template>
<script>

export default {
  name: 'LoadingSpinner',
  props: ['dwidth', 'dlength'],
  data () {
    return {
    }
  },
  computed: {
    styling: function () {
      return {
        width: this.dwidth,
        height: this.dlength
      }
    }
  }
}
</script>

<style scoped>
#cover-spin{
  position: fixed;
  background-color: gray;
  left:0;right:0;top:0;bottom:0;
  opacity: 0.7;
  z-index: 9999;
  display: '';
}
@-webkit-keyframes spin {
  from{-webkit-transform:rotate(0deg);}
  to{-webkit-transform:rotate(360deg);}
}
@keyframes spin {
  from{transform:rotate(0deg);}
  to{transform:rotate(360deg);}
}
#cover-spin::after {
    content: '';
    display: block;
    position: absolute;
    left: 48%;top: 40%;
    width:40px;height: 40px;
    border-style: solid;
    border-color:black;
    border-top-color: lightgrey;
    border-width: 4px;
    border-radius: 50%;
    -webkit-animation: spin .8s linear infinite;
    animation: spin .8s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingSpinner.vue